module.exports = __webpack_public_path__ + "img/feature_banner.c8115384.png";